import { ScreenNames } from '../constants/screens';
import { RouteConstants } from '../constants/routes';
import { GlobalRoutesInterface } from './types';
import { ComponentsMap } from '../constants/ComponentsMap';

const GlobalRoutes: Array<GlobalRoutesInterface> = [
  {
    route: RouteConstants.HOME,
    title: ScreenNames.HOME,
    component: ComponentsMap.Dashboard,
  },
  {
    route: RouteConstants.LOGIN,
    title: ScreenNames.LOGIN,
    component: ComponentsMap.Login,
  },
  {
    route: RouteConstants.SIGNUP,
    title: ScreenNames.SIGNUP,
    component: ComponentsMap.SignUp,
  },
  {
    route: RouteConstants.VERIFY_USER,
    title: ScreenNames.VERIFY_USER,
    component: ComponentsMap.VerifyUser,
  },
  {
    route: RouteConstants.FORGOT_PASSWORD,
    title: ScreenNames.FORGOT_PASSWORD,
    component: ComponentsMap.ForgotPassword,
  },
  {
    route: RouteConstants.RESET_PASSWORD,
    title: ScreenNames.RESET_PASSWORD,
    component: ComponentsMap.ResetPassword,
  },
];

export default GlobalRoutes;
